<template>
  <div>
    <div class="section-heading">
      <div class="container">
        <h1 class="section-heading__title">
          Mercado
        </h1>
        <div class="section-heading__actions">
          <div class="hidden-desktop">
            <div v-if="currentUser.canBuy && currentUser.canSell">
              <vs-dropdown vs-custom-content vs-trigger-click>
                <button class="btn btn--with-icon btn--small">
                  <vs-icon icon="add_circle"/>
                  Crear
                </button>
                <vs-dropdown-menu class="create-offer-dropdown">
                  <router-link to="create-buyer-offer">Oferta de compra</router-link>
                  <router-link to="create-seller-offer">Oferta de venta</router-link>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
            <div v-else>
              <button v-if="currentUser.canBuy" class="btn btn--with-icon btn--small buyer" @click="createOffer('buy')">
                <vs-icon icon="add_circle"/>
                Crear
              </button>

              <button v-if="currentUser.canSell" class="btn btn--with-icon btn--small seller" @click="createOffer('sell')">
                <vs-icon icon="add_circle"/>
                Crear
              </button>
            </div>
          </div>
          <button v-if="currentUser.canBuy" class="btn buyer hidden-mobile" @click="createOffer('buy')" :offerType="'buy'" data-test="button-createofferofbuy">Crear oferta de compra</button>
          <button v-if="currentUser.canSell" class="btn seller hidden-mobile" @click="createOffer('sell')" :offerType="'sell'" data-test="button-createofferofsell">Crear oferta de venta</button>
        </div>
      </div>
    </div>
    <div class="container mg-top">
      <a class="contact-info" href=" https://api.whatsapp.com/send?phone=+5493416806308&text=Hola!%20Quiero%20consultar%20por%20una%20oferta" target="_blank">
        Consultas
        <img alt="BCR logo" src="@/assets/images/whatsapp.svg" width="20">
        +54 9 341 680-6308
      </a>
      <OffersList :offers-states="['published', 'in_negotiation']"
                  :storeDestiny="'publishedList'"
                  :show-state-filter="false"
                  :filterSubtype="false"
                  :ref="'published'"
                  :autoload="true"
                  :market="true"
                  :userCanSell="currentUser.canSell"
                  :filter-by-state="false"
                  :key="'publishedList'">
        <template v-slot:offer-list="slotProps">
          <MarketList :offer="slotProps.offer" @get-offers="getOffers"/>
        </template>
      </OffersList>
    </div>
  </div>
</template>

<script>
import OffersList from '@/components/OffersList.vue'
import MarketList from '@/components/MarketList.vue'
import { mapState } from 'vuex'
import gql from 'graphql-tag'
import axios from 'axios'
import { print } from 'graphql'

axios.defaults.headers.common['referer-id'] = new Date().toLocaleString().replace(/[^\d]/g, '') + parseInt(Math.random() * 100000)

export default {
  components: {
    OffersList,
    MarketList
  },
  data () {
    return {
      attributes: {},
      errorMsg: []
    }
  },
  watch: {
    offerModal () {
      if (!this.offerModal) {
      }
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.User.currentUser
    }),
    showQuantityLeft () {
      if (this.offerForModal.quantityLeft != this.offerForModal.quantity) {
        return `${this.offerForModal.quantityLeft} de ${this.offerForModal.quantity}`
      }
      return this.offerForModal.quantity
    },
    isActive() {
      var estabArr = this.currentUser.organization.establishments
      var active = estabArr.filter(estab => estab.active == true )
      return active.length
    }
  },
  methods: {
    localePrice (price) {
      return '$/Kg ' + price.toLocaleString('es', { minimumFractionDigits: 2 })
    },
    localeDate (str) {
      return new Date(Date.parse(str) + 3.6e+6*3).toLocaleDateString()
      // return (new Date(str)).toLocaleDateString() 
    },
    getOffers () {
      this.$refs.published.getOffers()
    },
    createOffer(offerType) {
      if (this.isActive) {
        if (offerType == 'buy') {
          this.$router.push('create-buyer-offer')
        } else {
          this.$router.push('create-seller-offer')
        }
      } else {
        this.$vs.notify({
          title: 'Error',
          time: 8000,
          text: 'Para poder crear una oferta, primero deberá agregar al menos un establecimiento desde la sección "Administrar datos de empresa".',
          color: '#eb4d4b',
          position: 'top-center',
          icon: 'error'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.container.mg-top {
  position: relative;
}

.contact-info {
  position: absolute;
  top: -47px;
  display: inline-flex;
  align-content: center;
  justify-content: center;
  padding: 6px 16px;
  background: #f3f3f3;
  border-radius: 4px;
  font-size: .8rem;
  z-index: 2;

  img {
    width: 14px;
    margin: 0 4px 0 12px;
  }

  @media (max-width: 991px) {
    top: -43px;
    padding: 10px 24px;
    top: 0;
  }

  @media (max-width: 500px) {
    width: 100%;
    position: relative;
    top: 0;
    margin-bottom: 24px;
  }
}
</style>